import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import moment from 'moment'
import store from '@/store'
import message from '@/components/message'
import _forIn from 'lodash/forIn'
import { formatCodenamesCall } from '@/services/posts'
import { sendEmail } from '@/services/email'
import { forEach } from 'lodash'

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL

const generateCronExpression = (date) => {
	const dateObj = new Date(date)
	return `${dateObj.getMinutes()} ${dateObj.getUTCHours()} ${dateObj.getUTCDate()} ${dateObj.getUTCMonth() + 1} *`
}

const stateDefault = () => ({
  libelle: null,
  texte: null,
  typePost: null,
  photo: null,
  linkToVideo: null,
  actionButton: null,
  datePlanif: null,
  promoCode: null,
  eventBefore: null,
  eventAfter: null,
  offerLink: null,
  offerTime: null,
  offerConditions: null,
  offerBefore: null,
  offerAfter: null,
  UTM: null,
  eventLink: null,
  sendToStory: null,
  typePostInstagram: null,
  state: null,
  linkToVideoInstagram: null,
  publishToStoryInstagram: null,
  modalIA: false,
  loadingStatus: false,
  loadingStatusIAGeneration: false,
  network: null,
  modalStopCustom: false,
  loadingSendEmail: false
})

const postDefault = {
  id: null,
  reference: null,
  initial: {
    libelle: '',
    inputText: '',
    pictures: [],
    linkToVideo: null,
    iaPrompt: '',
    alreadyGeneratedAI: false
  },
  facebook: {
    inputText: null,
    libelle: '',
    pictures: [],
    linkToVideo: null,
    actionButton: null,
    urlAction: null,
    UTM: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  google: {
    libelle: null,
    typePost: 'STANDARD',
    inputText: '',
    pictures: [],
    linkToVideo: null,
    actionButton: null,
    urlAction: null,
    UTM: null,
    offerLink: null,
    offerConditions: null,
    offerDateBefore: null,
    offerDateAfter: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  instagram: {
    libelle: null,
    typePost: 'MEDIA',
    pictures: null,
    inputText: '',
    linkToVideo: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  linkedin: {
    libelle: null,
    pictures: null,
    linkToVideo: null,
    inputText: '',
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  photos: []
}
export default {
  namespaced: true,
  state: {
    post: {
      id: null,
      reference: null,
      diffusions: null,
      planifications: null,
      initial: {
        libelle: '',
        inputText: '',
        pictures: [],
        linkToVideo: null,
        iaPrompt: '',
        alreadyGeneratedAI: false
      },
      facebook: {
        inputText: '',
        libelle: '',
        pictures: [],
        linkToVideo: null,
        actionButton: null,
        urlAction: null,
        UTM: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      google: {
        libelle: '',
        typePost: 'STANDARD',
        inputText: '',
        pictures: [],
        linkToVideo: null,
        actionButton: null,
        urlAction: null,
        UTM: null,
        offerLink: null,
        offerConditions: null,
        offerDateBefore: null,
        offerDateAfter: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      instagram: {
        libelle: '',
        typePost: 'MEDIA',
        pictures: null,
        inputText: '',
        linkToVideo: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      linkedin: {
        libelle: '',
        pictures: null,
        inputText: '',
        linkToVideo: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      photos: []
    },
    customFacebook: false,
    customInstagram: false,
    customGoogle: false,
    customLinkedIn: false,
    googleCustom: false,
    facebookChecked: false,
    instagramChecked: false,
    googleChecked: false,
    linkedInChecked: false,
    libelle: null,
    texte: null,
    typePost: null,
    photo: null,
    actionButton: null,
    datePlanif: null,
    promoCode: null,
    eventBefore: null,
    eventAfter: null,
    offerLink: null,
    offerTime: null,
    offerConditions: null,
    offerBefore: null,
    offerAfter: null,
    UTM: null,
    eventLink: null,
    sendToStory: null,
    typePostInstagram: null,
    state: null,
    linkToVideoInstagram: null,
    publishToStoryInstagram: null,
    modalIA: false,
    loadingStatus: false,
    loadingStatusIAGeneration: false,
    network: null,
    currentPost: null,
    redirection: false,
    modalStopCustom: false,
    stopCustomNetwork: null,
    watcherNewPic: false,
    publishButtonAvailable: true,
    draftButtonAvailable: true,
    id: null,
    networkClicked: 'initial',
    create: null,
    edit: null,
    modalConfirmPublish: false,
    modalConfirmPublishNow: false,
    loadingSendEmail: false,
    modalDeletePlanifBrouillons: false
  },
  getters: {
    getLibelle: (state) => state.libelle,
    getTexte: (state) => state.texte,
    getTypePost: (state) => state.typePost,
    getPhoto: (state) => state.photo,
    getActionButton: (state) => state.actionButton,
    getDatePlanif: (state) => state.datePlanif,
    getPromoCode: (state) => state.promoCode,
    getEventBefore: (state) => state.eventBefore,
    getEventAfter: (state) => state.eventAfter,
    getOfferLink: (state) => state.offerLink,
    getOfferTime: (state) => state.offerTime,
    getOfferConditions: (state) => state.offerConditions,
    getOfferBefore: (state) => state.offerBefore,
    getOfferAfter: (state) => state.offerAfter,
    getModalIA: (state) => state.modalIA,
    getPostState: (state) => state.state,
    getLoadingStatus: (state) => state.loadingStatus,
    getLoadingStatusIAGeneration: (state) => state.loadingStatusIAGeneration,
    getUTM: (state) => state.UTM,
    getEventLink: (state) => state.eventLink,
    getTypePostInstagram: (state) => state.typePostInstagram,
    getState: (state) => state.state,
    getNetwork: (state) => state.network,
    getLinkToVideoInstagram: (state) => state.linkToVideoInstagram,
    getPublishToStoryInstagram: (state) => state.publishToStoryInstagram,
    getData: (state) => state.data,
    getCurrentPost: (state) => state.currentPost,
    getRedirection: (state) => state.redirection,
    getCustomFacebook: (state) => state.customFacebook,
    getCustomInstagram: (state) => state.customInstagram,
    getCustomGoogle: (state) => state.customGoogle,
    getCustomLinkedIn: (state) => state.customLinkedIn,
    getFacebookChecked: (state) => state.facebookChecked,
    getGoogleChecked: (state) => state.googleChecked,
    getInstagramChecked: (state) => state.instagramChecked,
    getLinkedInChecked: (state) => state.linkedInChecked,
    getInitial: (state) => state.initial,
    getDefaultPost: (state) => state.post,
    getModalStopCustom: (state) => state.modalStopCustom,
    getStopCustomNetwork: (state) => state.stopCustomNetwork,
    getWatcherNewPic: (state) => state.watcherNewPic,
    getPublishButtonAvailable: (state) => state.publishButtonAvailable,
    getDraftButtonAvailable: (state) => state.draftButtonAvailable,
    getId: (state) => state.post.id,
    getNetworkClicked: (state) => state.networkClicked,
    getCreate: (state) => state.create,
    getEdit: (state) => state.edit,
    getPhotos: (state) => state.post.photos,
    getPost: (state) => state.post,
    getModalConfirmPublish: (state) => state.modalConfirmPublish,
    getModalConfirmPublishNow: (state) => state.modalConfirmPublishNow,
    getLoadingSendEmail: (state) => state.loadingSendEmail,
    modalDeletePlanifBrouillons: (state) => state.modalDeletePlanifBrouillons
  },
  mutations: {
    SET_MODAL_DELETE_PLANIF_BROUILLONS (state, payload) {
      state.modalDeletePlanifBrouillons = payload
    },
    setPublishButtonAvailable (state, value) {
      state.publishButtonAvailable = value
    },
    setDraftButtonAvailable (state, value) {
      state.draftButtonAvailable = value
    },
    setLibelle (state, libelle) {
      state.libelle = libelle
    },
    setTexte (state, texte) {
      state.texte = texte
    },
    setTypePost (state, typePost) {
      state.typePost = typePost
    },
    setPhoto (state, photo) {
      state.photo = photo
    },
    setActionButton (state, actionButton) {
      state.actionButton = actionButton
    },
    setDatePlanif (state, datePlanif) {
      state.datePlanif = datePlanif
    },
    setPromoCode (state, promoCode) {
      state.promoCode = promoCode
    },
    setEventBefore (state, eventBefore) {
      state.eventBefore = eventBefore
    },
    setEventAfter (state, eventAfter) {
      state.eventAfter = eventAfter
    },
    setOfferLink (state, offerLink) {
      state.offerLink = offerLink
    },
    setOfferTime (state, offerTime) {
      state.offerTime = offerTime
    },
    setOfferConditions (state, offerConditions) {
      state.offerConditions = offerConditions
    },
    setOfferBefore (state, offerBefore) {
      state.offerBefore = offerBefore
    },
    setOfferAfter (state, offerAfter) {
      state.offerAfter = offerAfter
    },
    setReferencePost (state, reference) {
      state.post.reference = reference
    },
    setModalIA (state, modalIA) {
      state.modalIA = modalIA
    },
    setModalConfirmPublish (state, modalConfirmPublish) {
      state.modalConfirmPublish = modalConfirmPublish
    },
    setModalConfirmPublishNow (state, modalConfirmPublishNow) {
      state.modalConfirmPublishNow = modalConfirmPublishNow
    },
    setLoadingStatus (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    setUTM (state, UTM) {
      state.UTM = UTM
    },
    setLoadingStatusIAGeneration (state, loadingStatusIAGeneration) {
      state.loadingStatusIAGeneration = loadingStatusIAGeneration
    },
    setNetwork (state, network) {
      state.network = network
    },
    setEventLink (state, eventLink) {
      state.eventLink = eventLink
    },
    setTypePostInstagram (state, typePostInstagram) {
      state.typePostInstagram = typePostInstagram
    },
    setLinkToVideoInstagram (state, linkToVideoInstagram) {
      state.linkToVideoInstagram = linkToVideoInstagram
    },
    setPublishToStoryInstagram (state, publishToStoryInstagram) {
      state.publishToStoryInstagram = publishToStoryInstagram
    },
    setCurrentPost (state, currentPost) {
      state.currentPost = currentPost
    },
    setPost (state, post) {
      state.post = post
    },
    resetPost (state) {
      state.post = {
        id: null,
        reference: null,
        initial: {
          libelle: '',
          inputText: '',
          pictures: [],
          linkToVideo: null,
          iaPrompt: '',
          alreadyGeneratedAI: false
        },
        facebook: {
          inputText: '',
          libelle: '',
          pictures: [],
          linkToVideo: null,
          actionButton: null,
          urlAction: null,
          UTM: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        google: {
          libelle: '',
          typePost: 'STANDARD',
          inputText: '',
          pictures: [],
          linkToVideo: null,
          actionButton: null,
          urlAction: null,
          UTM: null,
          offerLink: null,
          offerConditions: null,
          offerDateBefore: null,
          offerDateAfter: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        instagram: {
          libelle: '',
          typePost: 'MEDIA',
          pictures: null,
          inputText: '',
          linkToVideo: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        linkedin: {
          libelle: '',
          pictures: null,
          inputText: '',
          linkToVideo: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        photos: []
      }
    },
    setPhotos (state, photos) {
      state.post.initial.pictures = photos
    },
    setLinkToVideo (state, linkToVideo) {
      state.post.linkToVideo = linkToVideo
    },
    resetState (state) {
      Object.assign(state, stateDefault())
    },
    setRedirection (state, redirection) {
      state.redirection = redirection
    },
    setId (state, id) {
      state.post.id = id
    },
    setNetworkClicked (state, networkClicked) {
      state.networkClicked = networkClicked
    },
    setCustomFacebook (state, customFacebook) {
      state.customFacebook = customFacebook
    },
    setCustomInstagram (state, customInstagram) {
      state.customInstagram = customInstagram
    },
    setCustomGoogle (state, customGoogle) {
      state.customGoogle = customGoogle
    },
    setCustomLinkedIn (state, customLinkedIn) {
      state.customLinkedIn = customLinkedIn
    },
    setCreate (state, create) {
      state.create = create
    },
    setEdit (state, edit) {
      state.edit = edit
    },
    setPlanifications (state, planifications) {
      state.post.planifications = planifications
    },
    setDiffusions (state, diffusions) {
      state.post.diffusions = diffusions
    },
    setOfferDateGoogle (state, dates) {
      state.post.google.offerDateBefore = dates[0]
      state.post.google.offerDateAfter = dates[1]
    },
    setInstagramChecked (state, instagramChecked) {
      state.instagramChecked = instagramChecked
      if (instagramChecked) {
        state.post.instagram.inputText = state.post.initial.inputText
        state.post.instagram.linkToVideo = state.post.initial.linkToVideo
      }
    },
    setFacebookChecked (state, facebookChecked) {
      state.facebookChecked = facebookChecked
      if (facebookChecked) {
        state.post.facebook.inputText = state.post.initial.inputText
        state.post.facebook.linkToVideo = state.post.initial.linkToVideo
      }
    },
    setGoogleChecked (state, googleChecked) {
      state.googleChecked = googleChecked
      if (googleChecked) {
        state.post.google.inputText = state.post.initial.inputText
        state.post.google.linkToVideo = state.post.initial.linkToVideo
      }
    },
    setLinkedInChecked (state, linkedInChecked) {
      state.linkedInChecked = linkedInChecked
      if (linkedInChecked) {
        state.post.linkedin.inputText = state.post.initial.inputText
        state.post.linkedin.linkToVideo = state.post.initial.linkToVideo
      }
    },
    checkPublishButtonState (state) {
      const user = store.getters.getUser
      if (((state.facebookChecked && user.haveFacebookEdito) || (state.instagramChecked && user.haveInstagramEdito) || (state.googleChecked && user.haveGMBEdito) || (state.linkedInChecked && user.haveLinkedInEdito)) && (state.post.initial.pictures.length > 0 || (state.post.initial.linkToVideo && state.post.initial.linkToVideo.length > 0))) {
        state.publishButtonAvailable = false
      } else {
        state.publishButtonAvailable = true
      }
    },
    checkDraftButtonState (state) {
      if (state.post.initial.inputText && state.post.initial.libelle && state.post.initial.inputText.length > 0 && state.post.initial.libelle.length > 0) {
        state.draftButtonAvailable = false
      } else {
        state.draftButtonAvailable = true
      }
    },
    setInitialInputText (state, inputText) {
      state.post.initial.inputText = inputText
    },
    updateInputTextInitial (state, inputText) {
      if (state.facebookChecked && !state.customFacebook && !state.post.facebook.alreadyPublished) {
        state.post.facebook.inputText = inputText
      }
      if (state.instagramChecked && !state.customInstagram && !state.post.instagram.alreadyPublished) {
        state.post.instagram.inputText = inputText
      }
      if (state.googleChecked && !state.customGoogle && !state.post.google.alreadyPublished) {
        state.post.google.inputText = inputText
      }
      if (state.linkedInChecked && !state.customLinkedIn && !state.post.linkedin.alreadyPublished) {
        state.post.linkedin.inputText = inputText
      }
      state.post.initial.inputText = inputText
    },
    updateLibelleInitial (state, libelle) {
      if (state.facebookChecked && !state.customFacebook) {
        state.post.facebook.libelle = libelle
      }
      if (state.instagramChecked && !state.customInstagram) {
        state.post.instagram.libelle = libelle
      }
      if (state.googleChecked && !state.customGoogle) {
        state.post.google.libelle = libelle
      }
      if (state.linkedInChecked && !state.customLinkedIn) {
        state.post.linkedin.libelle = libelle
      }
      state.post.initial.libelle = libelle
    },
    updateInputVideoInitial (state, value) {
      if (state.facebookChecked && !state.customFacebook) {
        state.post.facebook.linkToVideo = value
      }
      if (state.instagramChecked && !state.customInstagram) {
        state.post.instagram.linkToVideo = value
      }
      if (state.googleChecked && !state.customGoogle) {
        state.post.google.linkToVideo = value
      }
      if (state.linkedInChecked && !state.customLinkedIn) {
        state.post.linkedin.linkToVideo = value
      }
      state.post.initial.linkToVideo = value
    },
    setDefaultPost (state) {
      state.post = postDefault
    },
    setModalStopCustom (state, modalStopCustom) {
      state.modalStopCustom = modalStopCustom
    },
    setStopCustomNetwork (state, stopCustomNetwork) {
      state.stopCustomNetwork = stopCustomNetwork
    },
    setInitialValuesFacebook (state) {
      state.post.facebook = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        actionButton: null,
        urlAction: null,
        UTM: null
      }
    },
    setInitialValuesGoogle (state) {
      state.post.google = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        typePost: 'STANDARD',
        actionButton: null,
        urlAction: null,
        UTM: null,
        offerLink: null,
        offerConditions: null,
        offerDateBefore: null,
        offerDateAfter: null
      }
    },
    setInitialValuesInstagram (state) {
      state.post.instagram = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        typePost: 'MEDIA'
      }
    },
    setInitialValuesLinkedIn (state) {
      state.post.linkedin = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo
      }
    },
    setWatcherNewPic (state, watcherNewPic) {
      state.watcherNewPic = watcherNewPic
    },
    setupNewPostForIA (state) {
      state.post.initial.inputText = state.post.initial.iaPrompt

      if (!state.post.facebook.inputText && state.facebookChecked) {
        state.post.facebook.inputText = state.post.facebook.iaPrompt
      }
      if (!state.post.google.inputText && state.googleChecked) {
        state.post.google.inputText = state.post.google.iaPrompt
      }
      if (!state.post.instagram.inputText && state.instagramChecked) {
        state.post.instagram.inputText = state.post.instagram.iaPrompt
      }
      if (!state.post.linkedin.inputText && state.linkedInChecked) {
        state.post.linkedin.inputText = state.post.linkedin.iaPrompt
      }
    },
    checkPublished (state) {
      if(state.post.diffusions) {
        state.post.diffusions.forEach(function (diffusion) {
          if (diffusion.advertiserPublication.portal.code === 'GOOGLE_MY_BUSINESS_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.google.alreadyPublished = true
            state.customGoogle = false
          }
          if (diffusion.advertiserPublication.portal.code === 'FACEBOOK_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.facebook.alreadyPublished = true
            state.customFacebook = false
          }
          if (diffusion.advertiserPublication.portal.code === 'INSTAGRAM_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.instagram.alreadyPublished = true
            state.customInstagram = false
          }
          if (diffusion.advertiserPublication.portal.code === 'LINKEDIN_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.linkedin.alreadyPublished = true
          }
        })
      }
    },
    checkPlanned (state) {
      if (state.post.planifications) {
        state.post.planifications.forEach(function (planif) {
          if (planif.portails[0].code === 'GOOGLE_MY_BUSINESS_EDITO') {
            state.post.google.datePlanif = planif.scheduled.cronDate
            state.post.google.planned = true
            state.post.google.plannedId = planif.id
          }
          if (planif.portails[0].code === 'FACEBOOK_EDITO') {
            state.post.facebook.datePlanif = planif.scheduled.cronDate
            state.post.facebook.planned = true
            state.post.facebook.plannedId = planif.id
          }
          if (planif.portails[0].code === 'INSTAGRAM_EDITO') {
            state.post.instagram.datePlanif = planif.scheduled.cronDate
            state.post.instagram.planned = true
            state.post.instagram.plannedId = planif.id
          }
          if (planif.portails[0].code === 'LINKEDIN_EDITO') {
            state.post.linkedin.datePlanif = planif.scheduled.cronDate
            state.post.linkedin.planned = true
            state.post.linkedin.plannedId = planif.id
          }
        })
      }
    },
    setNewCaption (state, payload) {
      if (payload.network === 'facebook') {
        state.post.facebook.inputText = payload.text
        state.post.facebook.alreadyGeneratedAI = true
      } else if (payload.network === 'instagram') {
        state.post.instagram.inputText = payload.text
        state.post.instagram.alreadyGeneratedAI = true
      } else if (payload.network === 'google') {
        state.post.google.inputText = payload.text
        state.post.google.alreadyGeneratedAI = true
      } else if (payload.network === 'linkedin') {
        state.post.linkedin.alreadyGeneratedAI = true
      } else {
        state.post.initial.inputText = payload.text
        state.post.initial.alreadyGeneratedAI = true
      }
      state.modalIA = false
    },
    deleteCaption (state, network) {
      if (network === 'facebook') {
        state.post.facebook.inputText = null
      } else if (network === 'instagram') {
        state.post.instagram.inputText = null
      } else if (network === 'google') {
        state.post.google.inputText = null
      } else if (network === 'linkedin') {
        state.post.linkedin.inputText = null
      } else {
        state.post.initial.inputText = null
      }
    },
    searchPhotosNetworksFromPost (state) {
      if(state.currentPost.diffusions) {
        const diffusions = state.currentPost.diffusions
        forEach(diffusions, diffusion => {
          if (diffusion.advertiserPublication.portal.code === 'GOOGLE_MY_BUSINESS_EDITO') {
            state.post.google.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.google.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'FACEBOOK_EDITO') {
            state.post.facebook.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.facebook.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'INSTAGRAM_EDITO') {
            state.post.instagram.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.instagram.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'LINKEDIN_EDITO') {
            state.post.linkedin.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.linkedin.useAnotherPicture = true }
            }
        })
      }
    },
    setPostFromExisting (state) {
      state.post.id = state.currentPost.id
      state.post.initial.libelle = state.currentPost.titre
      state.post.reference = state.currentPost.reference
      state.post.etat = state.currentPost.etat
      if (state.currentPost.donnees.UBIFLOW_ORIGIN_ID) {
        state.post.UBIFLOW_ORIGIN_ID = state.currentPost.UBIFLOW_ORIGIN_ID
      }
      if (state.currentPost.donnees && state.currentPost.donnees.caption) {
        state.post.initial.inputText = state.currentPost.donnees.caption.valeur
      }
      state.post.initial.pictures = state.currentPost.photos
      if (state.currentPost.donnees.post_video_file_url_custom) {
        if (state.currentPost.donnees.post_video_file_url_custom.valeur.initial) {
            state.post.initial.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.initial
        }
      }
      if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.flux === 'ENRICHISSEMENT_IA') {
        state.post.initial.alreadyGeneratedAI = true
      }
      if (state.currentPost.donnees.facebook_caption) {
        state.facebookChecked = true
        state.post.facebook.inputText = state.currentPost.donnees.facebook_caption.valeur
        if (state.post.facebook.inputText !== state.post.initial.inputText) {
          state.customFacebook = true
        }
        if (state.currentPost.donnees.post_action_button_label_custom && state.currentPost.donnees.post_action_button_label_custom.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.actionButton = state.currentPost.donnees.post_action_button_label_custom.valeur.facebook
        }
        if (state.currentPost.donnees.post_action_url_custom && state.currentPost.donnees.post_action_url_custom.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.urlAction = state.currentPost.donnees.post_action_url_custom.valeur.facebook
        }
        if (state.currentPost.donnees.urls_trackees_sur_site_annonceur && state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.UTM = state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.facebook
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.facebook_caption && state.currentPost.donnees.facebook_caption.flux === 'ENRICHISSEMENT_IA') {
          state.post.facebook.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.facebook) {
          state.post.facebook.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.facebook
        }
      }
      if (state.currentPost.donnees.instagram_caption) {
        state.instagramChecked = true
        state.post.instagram.inputText = state.currentPost.donnees.instagram_caption.valeur
        if (state.post.instagram.inputText !== state.post.initial.inputText) {
          state.customInstagram = true
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.instagram_caption && state.currentPost.donnees.instagram_caption.flux === 'ENRICHISSEMENT_IA') {
          state.post.instagram.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.instagram) {
          state.post.instagram.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.instagram
        }
      }
      if (state.currentPost.donnees.linkedin_commentary) {
        state.linkedInChecked = true
        state.post.linkedin.inputText = state.currentPost.donnees.linkedin_commentary.valeur
        if (state.post.linkedin.inputText !== state.post.initial.inputText) {
          state.customLinkedIn = true
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.linkedin_commentary && state.currentPost.linkedin_commentary.flux === 'ENRICHISSEMENT_IA') {
          state.post.linkedin.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.linkedin) {
          state.post.linkedin.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.linkedin
        }
      }
      if (state.currentPost.donnees.google_localpost_summary) {
        state.googleChecked = true
        state.post.google.inputText = state.currentPost.donnees.google_localpost_summary.valeur
        if (state.post.google.inputText !== state.post.initial.inputText) {
          state.customGoogle = true
        }
        if (state.currentPost.donnees.post_type_custom && state.currentPost.donnees.post_type_custom.valeur.GMB) {
          state.post.google.typePost = state.currentPost.donnees.post_type_custom.valeur.GMB
        }
        if (state.currentPost.donnees.offre_date_debut && state.currentPost.donnees.offre_date_debut.valeur) {
          state.customGoogle = true
          state.post.google.offerDateBefore = state.currentPost.donnees.offre_date_debut.valeur
        }
        if (state.currentPost.donnees.offre_date_fin && state.currentPost.donnees.offre_date_fin.valeur) {
          state.customGoogle = true
          state.post.google.offerDateAfter = state.currentPost.donnees.offre_date_fin.valeur
        }
        if (state.currentPost.donnees.urls_trackees_sur_site_annonceur && state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.GMB) {
          state.customGoogle = true
          state.post.google.UTM = state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.GMB
        }
        if (state.currentPost.donnees.post_action_url_custom && state.currentPost.donnees.post_action_url_custom.valeur && state.currentPost.donnees.post_action_url_custom.valeur.GMB) {
          state.customGoogle = true
          state.post.google.offerLink = state.currentPost.donnees.post_action_url_custom.valeur.GMB
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.google_localpost_summary && state.currentPost.google_localpost_summary.flux === 'ENRICHISSEMENT_IA') {
          state.post.google.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.google) {
          state.post.google.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.google
        }
      }
    },
    setLoadingSendEmail (state, loadingSendEmail) {
      state.loadingSendEmail = loadingSendEmail
    },
    setPhotosForNetwork (state, { network, photos }) {
      if (network === 'initial') {
        state.post.initial.pictures = photos
      } else if (network === 'facebook') {
        state.post.facebook.pictures = photos
      } else if (network === 'instagram') {
        state.post.instagram.pictures = photos
      } else if (network === 'google') {
        state.post.google.pictures = photos
      } else if (network === 'linkedin') {
        state.post.linkedin.pictures = photos
      }
    },
    setFacebookPictures (state, photos) {
      state.post.facebook.pictures = photos
    },
    setInstagramPictures (state, photos) {
      state.post.instagram.pictures = photos
    },
    setGooglePictures (state, photos) {
      state.post.google.pictures = photos
    },
    setLinkedInPictures (state, photos) {
      state.post.linkedin.pictures = photos
    }
  },
  actions: {
    resetCaption (context, payload) {
      context.commit('setLoadingStatusIAGeneration', true)
      const annonceId = context.getters.getId
      let url = baseURL + '/annonce-post'
      let diffuseur = ''
      switch (payload) {
        case 'facebook':
          diffuseur = 'FACEBOOK_EDITO'
          break
        case 'instagram':
          diffuseur = 'INSTAGRAM_EDITO'
          break
        case 'google':
          diffuseur = 'GOOGLE_MY_BUSINESS_EDITO'
          break
        case 'linkedin':
          diffuseur = 'LINKEDIN_EDITO'
          break
      }

      if (diffuseur === '') {
        url = url + `?annonceId=${annonceId}`
      } else {
        url = url + `?annonceId=${annonceId}&diffuseurNomDeCode=${diffuseur}`
      }

      HTTP_HYPER_ESPACE_BACKEND.delete(url).then((response) => {
        if (response.status === 200) {
          context.commit('deleteCaption', payload)
          return HTTP_HYPER_ESPACE_BACKEND.get(url).then(response => {
            context.commit('setNewCaption', { text: response.data.text, network: payload })
          }).catch(error => {
            console.log({ type: 'error', message: error })
          })
        }
      }).catch(error => {
        return { type: 'error', message: error }
      })
        .finally(function () {
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')
          context.commit('setLoadingStatusIAGeneration', false)
          context.commit('setModalIA', false)
        })
    },
    async generatePayload (context, payload) {
      let annonceur = store.state.app.user.username

      const data = {
        annonceur: {
          login: annonceur
        },
        flux: {
          code: 'SAISIE_EDITO'
        },
        networkHeadLogin: store.state.app.user.advertiserLogin,
        planifications: context.dispatch('generateScheduledEvents', { annonceur: store.state.app.user.advertiserLogin }),
        annonce: {
          caption: context.getters.getDefaultPost.initial.inputText,
          titre: context.getters.getDefaultPost.initial.libelle,
          code_type: 31000,
          type_offre: 'Q',
          STATUS: payload.typePost
        }
      }
      if (context.getters.getDefaultPost.initial.iaPrompt) {
        data.annonce.post_ia_prompt = context.getters.getDefaultPost.initial.iaPrompt
      }
      if (context.getters.getPost.id) {
        data.id = context.getters.getPost.id
        data.annonce.reference = context.getters.getDefaultPost.reference
      }
      if (context.getters.getDefaultPost.facebook.actionButton || context.getters.getDefaultPost.google.actionButton) {
        data.annonce.post_action_button_label_custom = {}
      }
      if (context.getters.getDefaultPost.facebook.urlAction || context.getters.getDefaultPost.google.urlAction) {
        data.annonce.post_action_url_custom = {}
      }
      if (context.getters.getDefaultPost.facebook.iaPrompt || context.getters.getDefaultPost.google.iaPrompt || context.getters.getDefaultPost.instagram.iaPrompt || context.getters.getDefaultPost.linkedin.iaPrompt) {
        data.annonce.post_ia_prompt_custom = {}
      }
      if (context.getters.getMustUpdateDestination) {
        data.mustUpdateDestination = true
      }
      data.portalPictures = {}

      // Traitement des photos initiales
      const initialPictures = context.getters.getDefaultPost.initial.pictures
      if (initialPictures && initialPictures.length > 0) {
        data.pictures = await context.dispatch('processPhotos', {
          photos: initialPictures,
          network: 'initial'
        })
      }

      if (!data.annonce.post_video_file_url_custom) {
        data.annonce.post_video_file_url_custom = {}
      }
      data.annonce.post_video_file_url_custom.initial = context.getters.getDefaultPost.initial.linkToVideo

      if (context.getters.getDefaultPost.initial.iaPrompt) {
        data.annonce.post_ia_prompt = context.getters.getDefaultPost.initial.iaPrompt
      }

      // Traitement des photos pour chaque réseau
      if (context.getters.getFacebookChecked) {
        data.annonce.facebook_caption = context.getters.getDefaultPost.facebook.inputText
        if (context.getters.getDefaultPost.facebook.actionButton) {
          data.annonce.post_action_button_label_custom.facebook = context.getters.getDefaultPost.facebook.actionButton
        }
        if (context.getters.getDefaultPost.facebook.urlAction) {
          data.annonce.post_action_url_custom.facebook = context.getters.getDefaultPost.facebook.urlAction
        }
        if (context.getters.getDefaultPost.facebook.iaPrompt) {
          data.annonce.post_ia_prompt_custom.FACEBOOK = context.getters.getDefaultPost.facebook.iaPrompt
        }
        const facebookPictures = context.getters.getDefaultPost.facebook.pictures
        if (facebookPictures && facebookPictures.length > 0) {
          data.portalPictures.FACEBOOK_EDITO = await context.dispatch('processPhotos', {
            photos: facebookPictures,
            network: 'facebook'
          })
        }
        if (context.getters.getDefaultPost.facebook.linkToVideo) {
          data.annonce.post_video_file_url_custom.facebook = context.getters.getDefaultPost.facebook.linkToVideo
        }
      }
      if (context.getters.getGoogleChecked) {
        data.annonce.google_localpost_summary = context.getters.getDefaultPost.google.inputText
        if (context.getters.getDefaultPost.google.actionButton) {
          data.annonce.post_action_button_label_custom.google = context.getters.getDefaultPost.google.actionButton
        }
        if (context.getters.getDefaultPost.google.urlAction) {
          data.annonce.post_action_url_custom.google = context.getters.getDefaultPost.google.urlAction
        }
        if (context.getters.getDefaultPost.google.iaPrompt) {
          data.annonce.post_ia_prompt_custom.GMB = context.getters.getDefaultPost.google.iaPrompt
        }
        const googlePictures = context.getters.getDefaultPost.google.pictures
        if (googlePictures && googlePictures.length > 0) {
          data.portalPictures.GOOGLE_MY_BUSINESS_EDITO = await context.dispatch('processPhotos', {
            photos: googlePictures,
            network: 'google'
          })
        }
        if (context.getters.getDefaultPost.google.linkToVideo) {
          data.annonce.post_video_file_url_custom.google = context.getters.getDefaultPost.google.linkToVideo
        }
      }
      if (context.getters.getInstagramChecked) {
        data.annonce.instagram_caption = context.getters.getDefaultPost.instagram.inputText
        if (context.getters.getDefaultPost.google.iaPrompt) {
          data.annonce.post_ia_prompt_custom.INSTAGRAM = context.getters.getDefaultPost.instagram.iaPrompt
        }
        const instagramPictures = context.getters.getDefaultPost.instagram.pictures
        if (instagramPictures && instagramPictures.length > 0) {
          data.portalPictures.INSTAGRAM_EDITO = await context.dispatch('processPhotos', {
            photos: instagramPictures,
            network: 'instagram'
          })
        }
        if (context.getters.getDefaultPost.instagram.linkToVideo) {
          data.annonce.post_video_file_url_custom.instagram = context.getters.getDefaultPost.instagram.linkToVideo
        }
      }
      if (context.getters.getLinkedInChecked) {
        data.annonce.linkedin_commentary = context.getters.getDefaultPost.linkedin.inputText
        if (context.getters.getDefaultPost.linkedin.iaPrompt) {
          data.annonce.post_ia_prompt_custom.LINKEDIN = context.getters.getDefaultPost.linkedin.iaPrompt
        }
        const linkedinPictures = context.getters.getDefaultPost.linkedin.pictures
        if (linkedinPictures && linkedinPictures.length > 0) {
          data.portalPictures.LINKEDIN_EDITO = await context.dispatch('processPhotos', {
            photos: linkedinPictures,
            network: 'linkedin'
          })
        }
        if (context.getters.getDefaultPost.linkedin.linkToVideo) {
          data.annonce.post_video_file_url_custom.linkedin = context.getters.getDefaultPost.linkedin.linkToVideo
        }
      }

      data.planifications = await context.dispatch('generateScheduledEvents', { annonce: data.annonce })
      return data
    },
    generateScheduledEvents (context, payload) {
      const defaultCronExpression = '* * * * *'
      const post = context.getters.getPost
      const request = {}
      const planifications = []
      request.id = post.id
      request.cronExpression = defaultCronExpression

      // Si c'est un brouillon (type B), on ne génère pas de planifications
      if (payload && payload.annonce && payload.annonce.STATUS === 'B') {
        return []
      }

      if (context.getters.getFacebookChecked && !context.getters.getPost.facebook.alreadyPublished) {
        if (post.facebook.datePlanif) {
          planifications.push({
            code: 'FACEBOOK_EDITO',
            cronExpression: generateCronExpression(post.facebook.datePlanif)
          })
        } else {
          planifications.push({
            code: 'FACEBOOK_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getInstagramChecked && !context.getters.getPost.instagram.alreadyPublished) {
        if (post.instagram.datePlanif) {
          planifications.push({
            code: 'INSTAGRAM_EDITO',
            cronExpression: generateCronExpression(post.instagram.datePlanif)
          })
        } else {
          planifications.push({
            code: 'INSTAGRAM_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getGoogleChecked && !context.getters.getPost.google.alreadyPublished) {
        if (post.google.datePlanif) {
          planifications.push({
            code: 'GOOGLE_MY_BUSINESS_EDITO',
            cronExpression: generateCronExpression(post.google.datePlanif)
          })
        } else {
          planifications.push({
            code: 'GOOGLE_MY_BUSINESS_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getLinkedInChecked && !context.getters.getPost.linkedin.alreadyPublished) {
        if (post.linkedin.datePlanif) {
          planifications.push({
            code: 'LINKEDIN_EDITO',
            cronExpression: generateCronExpression(post.linkedin.datePlanif)
          })
        } else {
          planifications.push({
            code: 'LINKEDIN_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }

      return planifications
    },
    loadSocialPostEditorialById (context, id) {
      context.commit('setLoadingStatus', true)

      let url = baseURL + '/social-management-posts?universe=EDITO&annonceId=' + id
      const codenamesCall = formatCodenamesCall(null, true, true)

      const codenames = codenamesCall[0]

      url = url + '&portalCodesAnnonces=' + codenames
      codenamesCall[1].forEach(function (element) {
        url = url + '&linkedPortals[]=' + element
      })
      const posts = HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          context.commit('setCurrentPost', response.data.annonces[0])
          context.commit('setPlanifications', response.data.annonces[0].planifications)
          context.commit('setDiffusions', response.data.annonces[0].diffusions)
          context.commit('setPostFromExisting')
          context.commit('searchPhotosNetworksFromPost')
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.commit('checkPlanned')
          context.commit('checkPublished')
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')
          context.commit('setLoadingStatus', false)
        })
    },
    async generateIA (context, network) {
      context.commit('setLoadingStatusIAGeneration', true)
      try {
        const response = await HTTP_HYPER_ESPACE_BACKEND.get(`/annonce-post?annonceId=${context.getters.getPost.id}&diffuseurNomDeCode=${network.toUpperCase()}_EDITO`)
        context.commit('setNewCaption', { network, text: response.data.text })
        context.commit('setModalIA', false)
      } catch (error) {
        message.error(`Erreur : ${error}`)
        context.commit('setModalIA', false)
        throw error
      } finally {
        context.commit('setLoadingStatusIAGeneration', false)
      }
    },
    handleScheduled (context, payload) {
      const cronExpression = '* * * * *'
      const post = context.getters.getPost
      let newDate = null
      const request = {}
      request.id = post.id
      request.cronExpression = cronExpression
      if (payload.network === 'facebook') {
        if (post.facebook.datePlanif) {
          newDate = new Date(post.facebook.datePlanif)
        }
        if (post.facebook.plannedId) {
          request.idPlanif = post.facebook.plannedId
        }
        request.codenameNetwork = 'FACEBOOK_EDITO'
      }
      if (payload.network === 'instagram') {
        if (post.instagram.datePlanif) {
          newDate = new Date(post.instagram.datePlanif)
        }
        if (post.instagram.plannedId) {
          request.idPlanif = post.instagram.plannedId
        }
        request.codenameNetwork = 'INSTAGRAM_EDITO'
      }
      if (payload.network === 'linkedin') {
        if (post.linkedin.datePlanif) {
          newDate = new Date(post.linkedin.datePlanif)
        }
        if (post.linkedin.plannedId) {
          request.idPlanif = post.linkedin.plannedId
        }
        request.codenameNetwork = 'LINKEDIN_EDITO'
      }
      if (payload.network === 'google') {
        if (post.google.datePlanif) {
          newDate = new Date(post.google.datePlanif)
        }
        if (post.google.plannedId) {
          request.idPlanif = post.google.plannedId
        }
        request.codenameNetwork = 'GOOGLE_MY_BUSINESS_EDITO'
      }
      if (newDate) {
        request.cronExpression = `${newDate.getMinutes()} ${newDate.getUTCHours()} ${newDate.getUTCDate()} ${newDate.getUTCMonth() + 1} *`
      }
      context.dispatch('handleRequest', request)
    },
    handleRequest (context, payload) {
      const idAnnonceur = store.getters.getSitimmoUser.id
      const login = store.getters.getSitimmoUser.login
      const payloadToApi = {
        annonceurId: idAnnonceur,
        annonceurLogin: login,
        annonces: [parseInt(payload.id)],
        type: 'MANUEL',
        scheduled: {
          cronExpression: payload.cronExpression,
          status: '1'
        },
        cancelBy: null,
        portails: [{ code: payload.codenameNetwork, value: null }]
      }

      const url = baseURL + '/socialposts'

      if (payload.idPlanif) {
        const idPlanif = payload.idPlanif
        const payloadDelete = {
          data: {
            id: idPlanif
          }
        }
        const replyDelete = HTTP_HYPER_ESPACE_BACKEND
          .delete(url, payloadDelete)
          .then(response => {
          })
          .catch(error => {
            message.error('Erreur : ' + error)
            return {
              type: 'error',
              message: error
            }
          })
          .finally(function () {

          })
      }

      const reply = HTTP_HYPER_ESPACE_BACKEND
        .post(url, payloadToApi)
        .then(response => {
        })
        .catch(error => {
          console.log('Erreur : ' + error)
          //message.error('Erreur : ' + error)
          return {
            type: 'error',
            message: error
          }
        })
        .finally(function () {

        })
    },
    handlePublish (context) {
      context.commit('setLoadingStatus', true)
      context.dispatch('validatePost', { typePost: 'A', publish: true })
      context.commit('setLoadingStatus', false)
    },
    async processPhotos (context, { photos, network }) {
      context.commit('setLoadingStatus', true)
      try {
        // Nettoyer les photos en base64
        if (!photos || photos.length === 0) return []

        const processedPhotos = await Promise.all(photos.map(async (photo) => {
          const processedPhoto = { ...photo }

          if (photo.type && photo.type === 'base64') {
            processedPhoto.value = photo.url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
          } else {
            processedPhoto.type = 'base64'
            processedPhoto.value = photo.chaine_source
            delete processedPhoto.nom_source
            delete processedPhoto.chaine_source
          }

          delete processedPhoto.url
          delete processedPhoto.url_miniature

          return processedPhoto
        }))

        context.commit('setPhotos', processedPhotos)
        if (network === 'facebook') {
          context.commit('setFacebookPictures', processedPhotos)
        } else if (network === 'instagram') {
          context.commit('setInstagramPictures', processedPhotos)
        } else if (network === 'google') {
          context.commit('setGooglePictures', processedPhotos)
        } else if (network === 'linkedin') {
          context.commit('setLinkedInPictures', processedPhotos)
        }
        context.commit('setLoadingStatus', false)
        return processedPhotos
      } catch (error) {
        context.commit('setLoadingStatus', false)
        throw error
      }
    },
    async validatePost (context, payload) {
      context.commit('setLoadingStatus', true)
      if (payload.generateIA) {
        context.commit('setLoadingStatusIAGeneration', true)
      }
      const post = await context.dispatch('generatePayload', payload)

      const url = '/socialposts/post/treatment'
      const reply = HTTP_HYPER_ESPACE_BACKEND.post(url, post)
        .then(response => {
          context.commit('setId', response.data.ad.id)
          context.commit('setReferencePost', response.data.ad.reference)
          context.commit('setEdit', true)
          context.commit('setCreate', false)
          if (payload.generateIA) {
            context.dispatch('resetCaption', { network: payload.network, annonceur: response.data.ad.advertiser.login })
          }
          context.commit('searchPhotosNetworksFromPost')
        })
        .catch(error => {
          console.log('Erreur : ' + error)
          return {
            type: 'error',
            message: error
          }
        })
        .finally(function () {
          context.commit('setLoadingStatus', false)
          if (!payload.generateIA) {
            context.commit('setRedirection', true)
          }
        })
    },
    deletePlanif (context) {
      const post = context.getters.getPost
      const url = '/socialposts'
      if (post.planifications && post.planifications.length > 0) {
        const planifs = post.planifications
        planifs.forEach((planif, index) => {
          const payloadDelete = {
            data: {
              id: planif.id,
              annonceurId: planif.annonceurId,
              annonceurLogin: planif.annonceurLogin
            }
          }
          const replyDelete = HTTP_HYPER_ESPACE_BACKEND.delete(url, payloadDelete)
            .then(response => {
            })
            .catch(error => {
              console.log('Erreur : ' + error)
              //message.error('Erreur : ' + error)
              return {
                type: 'error',
                message: error
              }
            })
            .finally(function () {

            })
        })
      }
    },
    sendEmailEnableNetwork (context, payload) {
      context.commit('setLoadingSendEmail', true)
      const sitimmoUser = store.getters.getSitimmoUser
      const mailData = {
        to: processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_RC,
        subject: 'Post éditorial : Demande de branchement depuis l\'espace client' + ' - ' + sitimmoUser.login,
        content: 'Bonjour,\n' +
          'L\'annonceur ' + sitimmoUser.login + ' (https://gestionnaire.ubiflow.net/fr/annonceurs/annonceur/' + sitimmoUser.id + ') souhaite gérer ses posts éditoriaux pour sa page ' + payload + ' depuis son Espace Client.\n' +
          'Merci de prendre contact avec lui.' + ' Bonne journée'
      }

      sendEmail(mailData).then(r => message({ message: 'Votre demande a bien été envoyée. Notre équipe va revenir vers vous dans les meilleurs délais.', type: 'success' }))
      context.commit('setLoadingSendEmail', false)
    },
    setDraft (context, payload) {
      const data = {}
      console.log(store.getters.getSitimmoUser)
      data.annonceur = {
        login: store.getters.getSitimmoUser.login
      }
      data.flux = {
        code: 'SAISIE_EDITO'
      }
      data.annonce = {}
      data.STATUS = 'B'
      const url = baseURL + '/annonce'

      const draft = HTTP_HYPER_ESPACE_BACKEND
        .patch(url + '/' + context.getters.getId, data)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
    },
    deletePostEditorial (context, payload) {
      context.commit('setLoadingStatus', true)
      const params = {
        data: [payload]
      }
      const url = '/annonce'
      const deletePost = HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          console.log('deleted')
        })
    },
    createPostFromModel (context, payload) {
      const data = {
        id: payload.id,
        reference: payload.reference
      }

      if (payload.fromReseau) {
        data.dstAnnonceur = store.getters.getSitimmoUser.id
      }

      return HTTP_HYPER_ESPACE_BACKEND
        .post('/createPostFromModel', data)
        .then(response => {
          context.commit('setCurrentPost', response.data.ad)
          context.commit('setPlanifications', response.data.ad)
          context.commit('setDiffusions', response.data.ad)
          context.commit('setPostFromExisting')
          context.commit('setId', response.data.ad.id)
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')

        })
        .catch(error => {
          return { type: 'error', message: error }
        })
    }
  }
}
